import { render, staticRenderFns } from "./programcontentscomponent.vue?vue&type=template&id=5604397d&"
import script from "./programcontentscomponent.vue?vue&type=script&lang=ts&"
export * from "./programcontentscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports